import { defineComponent as _defineComponent } from 'vue'
import GuideItem from '@/components/editorial/GuideItem.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { useArticleList } from '@/helpers/composables/useArticleList';
import { BackdropProfile, ImageFormat } from '@/@types/graphql-types';

interface GuideListProps {
	listSize?: number;
	inline?: boolean;
	entityId?: string;
	h4Heading?: boolean;
	isTitle?: boolean;
	relatedArticleId?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideList',
  props: {
    listSize: { default: 15 },
    inline: { type: Boolean },
    entityId: null,
    h4Heading: { type: Boolean },
    isTitle: { type: Boolean },
    relatedArticleId: null
  },
  setup(__props: any) {

const props = __props as { listSize: number, inline?: boolean, entityId?: string, h4Heading?: boolean, isTitle?: boolean, relatedArticleId?: number };



const { articles } = useArticleList({
	pageSize: props.listSize,
	entityId: props.entityId,
	isTitle: props.isTitle,
	profile: BackdropProfile.S480,
	format: ImageFormat.Jpg,
	relatedArticleId: () => props.relatedArticleId,
});

return { __sfc: true,props, articles, GuideItem, HiddenHorizontalScrollbar }
}

})